import React from 'react';
import FilterInputField from '../../../components/TableFilter/ColumnsFilters/FilterInputField';
import FilterSelect from '../../../components/TableFilter/ColumnsFilters/FilterSelect';
import FilterTreeSelect from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';

export function contingentColumns({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 60,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('monitoring_columnLocation'),
      accessor: 'legal_locality',
      Filter: (
        <FilterTreeSelect
          lookupId="60"
          name="legalLocality"
          lang={lang}
          filter={item => item.ARM_gu === 'true' && item.code !== '190000000'}
        />
      )
    },
    {
      Header: t('monitoring_columnBin'),
      accessor: 'bin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="bin" type="number" />
    },
    {
      Header: t('monitoring_columnPOName'),
      accessor: 'ru_name',
      Filter: <FilterInputField name="ruName" type="text" />
    },
    {
      Header: t('monitoring_columnPOType'),
      accessor: 'form_ownership',
      style: { textAlign: 'center' },
      Filter: (
        <FilterSelect name="formOwnership" dictCode="gu_form_ownership" lang={lang} />
      )
    },
    {
      Header: t('monitoring_columnKindergartenMiniCenter'),
      accessor: 'sub_types',
      Filter: (
        <FilterSelect
          name="subTypes"
          dictCode="230"
          lang={lang}
          dictFilter={item => item.code.startsWith('01.')}
        />
      )
    },
    {
      Header: t('monitoring_columnCount'),
      accessor: 'count',
      maxWidth: 140,
      style: { textAlign: 'center' },
      filterable: false
    }
  ];
}
